import {IOnlineCondolenceDetails} from '../../types/resources/OnlineCondolenceDetails';
import FuneralDirectorCard from '../FuneralDirector/FuneralDirectorCard';
import styled from 'styled-components';
import Panel from '../Panel';
import {useTranslation} from 'react-i18next';
import DateUtils from '../../utils/DateUtils';
import * as DOMPurify from 'dompurify';
import FuneralDirectorListItem from '../FuneralDirector/FuneralDirectorListItem';
import StringUtils from '../../utils/StringUtils';
import {isMobile} from 'react-device-detect';

const FuneralServicesWrapper = styled.div`
    display: grid;
    grid-template-columns: 2fr 1fr;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
`

const Table = styled.table`
    width: max-content;
`

const TableHeader = styled.th.attrs({
    className: 'cr-text-alert cr-bold cr-pr-xl cr-pb',
})`
    text-align: left;
`

const TableCell = styled.td.attrs({
   className: 'cr-pr',
})`
`

type TProps = {
    onlineCondolence: IOnlineCondolenceDetails;
}

const FuneralInfo = ({onlineCondolence}: TProps) => {
    const {t} = useTranslation();

    const date = onlineCondolence.funeralServiceDateTime ? DateUtils.getHumanDate(onlineCondolence.funeralServiceDateTime as Date) : null;
    const time = onlineCondolence.funeralServiceDateTime ? DateUtils.getHumanTime(onlineCondolence.funeralServiceDateTime as Date) : null;

    const hasInfo = (
        (onlineCondolence.description && !StringUtils.isHtmlEmpty(onlineCondolence.description))
        || (onlineCondolence.funeralServiceDescription && !StringUtils.isHtmlEmpty(onlineCondolence.funeralServiceDescription))
        || (onlineCondolence.funeralServicePreferences && !StringUtils.isHtmlEmpty(onlineCondolence.funeralServicePreferences))
        || onlineCondolence.funeralServiceDateTime
    );

    const hasFuneralDirectorInfo = (
        onlineCondolence.assignedToDisplayName
        || onlineCondolence.assignedToEmailAddress
        || onlineCondolence.assignedToImageUrl
        || onlineCondolence.assignedToPhoneNumber
    );

    return hasInfo
        ?
            <FuneralServicesWrapper className="cr-gap-lg cr-container">
                <Panel>
                    <div className="cr-my cr-flex cr-flex-col cr-gap-lg cr-justify-between">
                        {onlineCondolence.description &&
                            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(onlineCondolence.description)}}/>
                        }
                        {onlineCondolence.funeralServiceDescription &&
                            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(onlineCondolence.funeralServiceDescription)}}/>
                        }
                        {onlineCondolence.funeralServicePreferences &&
                            <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(onlineCondolence.funeralServicePreferences)}}/>
                        }
                        {(date || time) &&
                            <Table>
                                <tbody>
                                <tr>
                                    {date &&
                                        <TableHeader>{t('date')}</TableHeader>
                                    }
                                    {time &&
                                        <TableHeader>{t('time')}</TableHeader>
                                    }
                                </tr>
                                <tr>
                                    {date &&
                                        <TableCell>{date}</TableCell>
                                    }
                                    {time &&
                                        <TableCell>{time}</TableCell>
                                    }
                                </tr>
                                </tbody>
                            </Table>
                        }
                    </div>
                </Panel>
                { hasFuneralDirectorInfo &&
                    <FuneralDirectorCard details={onlineCondolence}/>
                }
            </FuneralServicesWrapper>
        : hasFuneralDirectorInfo
            ?
                <div className="cr-container">
                    {isMobile
                        ? <FuneralDirectorCard details={onlineCondolence}/>
                        : <FuneralDirectorListItem details={onlineCondolence}/>
                    }
                </div>
            : null
        ;
}

export default FuneralInfo;
